import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectProposalComparison from '@app/views/ProjectProposalComparison';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectProposalComparison)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
